import { useNavigate } from 'react-router-dom';
import { Pane, Heading, Text, Button, majorScale } from 'evergreen-ui';
import { WarningSignIcon, HomeIcon, RefreshIcon } from 'evergreen-ui';

const ErrorPage = () => {
  const navigate = useNavigate();

  const goToHome = () => navigate('/');

  return (
    <Pane display="flex" alignItems="center" justifyContent="center" height="100vh" padding={majorScale(4)} background="tint2">
      <Pane elevation={1} background="white" padding={majorScale(4)} borderRadius={8} width="100%" maxWidth={760} textAlign="center">
        <Pane display="flex" flexDirection="column" alignItems="center">
          <WarningSignIcon color="danger" size={56} />
          <Heading size={900} marginTop={majorScale(2)}>Ops! Qualcosa è andato storto</Heading>
          <Text size={500} marginTop={8} color="muted">Non siamo riusciti a caricare la pagina richiesta. Prova a tornare alla home o ricaricare la pagina.</Text>
          <Pane display="flex" gap={majorScale(2)} marginTop={majorScale(3)} justifyContent="center">
            <Button appearance="primary" intent="success" iconBefore={HomeIcon} onClick={goToHome}>Vai alla home</Button>
            <Button appearance="default" iconBefore={RefreshIcon} onClick={() => window.location.reload()}>Ricarica</Button>
          </Pane>
          <Text size={300} marginTop={majorScale(3)} color="muted">Se il problema persiste, contatta l'amministratore.</Text>
        </Pane>
      </Pane>
    </Pane>
  );
  
};

export default ErrorPage;